import React, { Component } from 'react'
import { Field, Form, reduxForm } from 'redux-form'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import Autosuggest from 'features/Autosuggest'
import SelectPretty from 'components/Input/SelectPretty'
import s from './NumberSearch.scss'
import pickleSearch from 'static/images/pickles/search.png'

class NumbersSearchComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tabIndex: 0,
    }
  }
  componentWillMount() {
    const { getAvailable1300Numbers, getAvailable1800Numbers, tabs } = this.props
    tabs.forEach(tab => {
      if (tab.type === '1300-standard') {
        getAvailable1300Numbers()
      }
      if (tab.type === '1800-standard') {
        getAvailable1800Numbers()
      }
    })
  }
  submit = data => {
    const { showNumbersFormModal, tabs } = this.props
    const tab = tabs[this.state.tabIndex]

    let numberType
    if (tab.type.includes('1300')) {
      numberType = '1300'
    } else if (tab.type.includes('1800')) {
      numberType = '1800'
    } else {
      numberType = tab.type
    }

    showNumbersFormModal({
      numberType,
      premiumNumber: data.premiumNumber,
      standardNumber: data.standardNumber,
      numberWithLetters: data.numberWithLetters,
      premiumNumberMonthlyFee: data.premiumNumberMonthlyFee,
      numberSelected: data.numberSelected,
    })
  }
  inputs = {
    '1300-premium': ({ onSuggestionSelected }) => (
      <Field
        component={Autosuggest}
        autosuggestType="smartnumber"
        numberType="1300"
        onSuggestionSelected={onSuggestionSelected}
        placeholder="Search premium 1300 numbers"
        hideDot
        name="premiumNumber"
      />
    ),
    '1800-premium': ({ onSuggestionSelected }) => (
      <Field
        component={Autosuggest}
        autosuggestType="smartnumber"
        numberType="1800"
        onSuggestionSelected={onSuggestionSelected}
        placeholder="Search premium 1800 numbers"
        hideDot
        name="premiumNumber"
      />
    ),
    '1300-standard': ({ onSuggestionSelected, availableNumbers1300 }) => (
      <Field
        component={SelectPretty}
        placeholder="Search 1300 numbers"
        options={availableNumbers1300.map(number => ({
          value: number,
          name: number,
        }))}
        name="standardNumber"
      />
    ),
    '1800-standard': ({ onSuggestionSelected, availableNumbers1800 }) => (
      <Field
        component={SelectPretty}
        placeholder="Search 1800 numbers"
        options={availableNumbers1800.map(number => ({
          value: number,
          name: number,
        }))}
        name="standardNumber"
      />
    ),
    local: ({ onSuggestionSelected }) => (
      <Field
        component={Autosuggest}
        autosuggestType="twilio"
        numberType="local"
        onSuggestionSelected={onSuggestionSelected}
        placeholder="Search local numbers"
        hideDot
        name="standardNumber"
      />
    ),
    mobile: ({ onSuggestionSelected }) => (
      <Field
        component={Autosuggest}
        autosuggestType="twilio"
        numberType="mobile"
        onSuggestionSelected={onSuggestionSelected}
        placeholder="Search mobile numbers"
        hideDot
        name="standardNumber"
      />
    ),
  }
  render() {
    const {
      name,
      handleSubmit,
      availableNumbers1300,
      availableNumbers1800,
      change,
      style,
      tabs,
    } = this.props
    const { tabIndex } = this.state
    const tab = tabs[tabIndex]
    const Input = this.inputs[tab.type]

    const onSuggestionSelected = (event, { suggestion }) => {
      if (tab.type.includes('premium')) {
        change('premiumNumber', suggestion.value)
        change('premiumNumberMonthlyFee', suggestion.meta.premiumNumberMonthlyFee)
      } else {
        change('standardNumber', suggestion.value)
      }
      change('numberSelected', suggestion.value)
      change('numberWithLetters', suggestion.meta.numberWithLetters)
    }

    return (
      <Form onSubmit={handleSubmit(this.submit)} className={s.formTabbed} style={style}>
        <div className={cn(sLay['layout-row'], sLay['layout-align-start-center'])}>
          <img className={s.avatar} src={pickleSearch} />
          <div className={s.searchBar}>
            <div className={s.input}>
              <Input
                onSuggestionSelected={onSuggestionSelected}
                availableNumbers1800={availableNumbers1800}
                availableNumbers1300={availableNumbers1300}
              />
              <div className={s.tabs}>
                {tabs.map((tab, idx) => (
                  <div
                    key={idx}
                    className={cn({ [s.active]: tabIndex === idx })}
                    onClick={() => {
                      this.setState({ tabIndex: idx })
                      if (tabIndex !== idx) {
                        change('standardNumber', '')
                        change('numberWithLetters', '')
                        change('premiumNumber', '')
                        change('premiumNumberMonthlyFee', '')
                        change('numberSelected', '')
                      }
                    }}
                  >
                    {tab.name}
                  </div>
                ))}
              </div>
            </div>
            <Button color="tertiary" type="submit">
              Select
            </Button>
          </div>
        </div>
      </Form>
    )
  }
}

export default reduxForm({
  destroyOnUnmount: false,
})(NumbersSearchComponent)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumberSearch/NumberSearch.jsx